import { Button } from "../Elements";
import { useState } from "react";
import Modal from "../Modal";

export default function BottomButtons(props) {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="w-full">
      <div className="w-full flex flex-row justify-end">
        <div className="mx-4 p-2 space-x-4">
          <Button
            size="lg"
            color="primary"
            hover="primary"
            type="button"
            callback={() => {
            props.onSubmitForm();
         
            }}
            loading={props.loadingVisible}
            disabled={props.loadingVisible}
          >
            Ödeme Linki Oluştur
          </Button>
          <Modal openModal={openModal} setOpenModal={setOpenModal}>
            <div>
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3 className="text-md leading-6 font-medium text-gray-900">
                    SMS/Email Paketiniz Tükenmiştir
                  </h3>
                  <div>
                    <div className="mt-4">
                      <img
                        className="text-error h-10 w-10"
                        src="/icons/basarisiz.svg"
                        alt="error"
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <p className="text-sm text-gray-500">
                      SMS/Email paketiniz tükenmiştir. Ödeme linki oluşturmak
                      için SMS/E-mail paketi satın almanız gerekmektedir.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-5 mt-4 flex justify-end space-x-2">
                <Button
                  color="gray"
                  hover="gray"
                  size="xs"
                  callback={() => setOpenModal(false)}
                >
                  İptal
                </Button>
                <Button
                  color="primary"
                  hover="primary"
                  size="xs"
                  callback={() => setOpenModal(false)}
                >
                  Sipariş Portalına Gidin
                </Button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
}
